import { Users, FileText, Calendar, Truck, Package, Menu, LogOut } from "lucide-react";

export default function Sidebar({
user,
collapsed,
setCollapsed,
activePage,
setActivePage,
onLogout
}) {
const adminItems = [
{ id: "contractors", label: "Klienci", icon:
<Users size={20} /> },
{ id: "orders", label: "Zlecenia", icon:
<FileText size={20} /> },
{ id: "planning", label: "Planowanie", icon:
<Calendar size={20} /> },
{ id: "pickup", label: "Odbiór", icon:
<Truck size={20} /> },
{ id: "packages", label: "Pojemniki", icon:
<Package size={20} /> },
];

const userItems = [
{ id: "pickup", label: "Odbiór", icon:
<Truck size={20} /> },
];

const items = user?.role_id === "1" ? adminItems : userItems;

return (
<aside className={`fixed top-0 left-0 h-screen bg-green-700 text-white ${collapsed ? "w-20" : "w-64" } transition-all
  flex flex-col`}>
  <div className="p-0 flex justify-between items-center border-b border-green-600">
<button
  onClick={() => setCollapsed(!collapsed)}
  className="w-full flex justify-center p-3 hover:bg-green-600"
>
  <Menu size={20} />
</button>
  </div>

  <nav className="flex-1 p-2 space-y-1 overflow-y-auto">
    {items.map(item => (
    <button key={item.id} onClick={()=> setActivePage(item.id)}
      className={`rounded-lg transition
      ${collapsed ? "flex justify-center p-3 w-full" : "flex items-center gap-3 p-3 w-full"}
      ${activePage === item.id ? "bg-green-600" : "hover:bg-green-600"}`}
      >
      <div className="flex items-center justify-center w-6 h-6">
        {item.icon}
      </div>

      {!collapsed && <span>{item.label}</span>}
    </button>
    ))}
  </nav>

<button
  onClick={onLogout}
  className={`w-full flex items-center hover:bg-green-600 border-t border-green-600
    ${collapsed ? "justify-center p-3" : "gap-3 p-3"}`}
>
  <div className="flex items-center justify-center w-6 h-6">
    <LogOut size={20} />
  </div>

  {!collapsed && "Wylogowanie"}
</button>
</aside>
);
}